import React from "react";
import { Container, Row, Col, Card, Accordion, Image } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import simProfile1 from "../../assets/img/docs/simProfile-1.png";
import simProfile2 from "../../assets/img/docs/simProfile-2.png";
import simProfile3 from "../../assets/img/docs/simProfile-3.png";
import simProfile4 from "../../assets/img/docs/simProfile-4.png";
import simProfile5 from "../../assets/img/docs/simProfile-5.png";
import simProfile6 from "../../assets/img/docs/simProfile-7.png";
import simProfile8 from "../../assets/img/docs/simProfile-8.png";
import simProfile9 from "../../assets/img/docs/simProfile-9.png";
import simProfile10 from "../../assets/img/docs/simProfile-10.png";
import simProfile11 from "../../assets/img/docs/simProfile-11.png";
import simProfile12 from "../../assets/img/docs/simProfile-12.png";

const Section = ({
  eventKey,
  title,
  description,
  bullets = [],
  fields = {}, // ✅ new support for fields
  images = [],
}) => (
  <Accordion.Item
    eventKey={eventKey}
    className="mb-3 border-0 shadow-sm rounded section-item"
  >
    <Accordion.Header className="fw-semibold fs-6">{title}</Accordion.Header>
    <Accordion.Body className="pt-3 section-body">
      {description && <p className="mb-3 text-muted">{description}</p>}

      {Object.keys(fields).length > 0 && (
        <ul className="section-fields mb-3">
          {Object.entries(fields).map(([key, value], i) => (
            <li key={i} className="mb-2">
              {value}
            </li>
          ))}
        </ul>
      )}

      {bullets?.length > 0 && (
        <ul className="section-list mb-3">
          {bullets.map((b, i) => (
            <li key={i} className="mb-2">
              {b}
            </li>
          ))}
        </ul>
      )}

      {images?.length > 0 && (
        <Row className="g-3 mt-2">
          {images.map(
            (src, i) =>
              src && (
                <Col md={6} key={i}>
                  <Image
                    src={src}
                    alt={`${title} screenshot ${i + 1}`}
                    className="section-image"
                    rounded
                    fluid
                  />
                </Col>
              )
          )}
        </Row>
      )}
    </Accordion.Body>
  </Accordion.Item>
);

const SimProfileDocs = () => {
  const { t } = useTranslation();

  const sections = [
    { key: "howToAccess", images: [simProfile1] },
    { key: "kpis", images: [simProfile2] },
    { key: "hlr", images: [simProfile3, simProfile4] },
    { key: "dataSessions", images: [simProfile5, simProfile6] },
    { key: "smsUsage", images: [simProfile8, simProfile9] },
    { key: "requests", images: [simProfile10, simProfile11] },
    { key: "watchdogs", images: [simProfile12] },
  ];

  return (
    <Container fluid className="py-5 sim-profile-docs">
      <Row className="justify-content-center mb-4">
        <Col lg={8}>
          <Card className="shadow-sm border-0 rounded-lg p-4">
            <Card.Body>
              <Card.Title className="display-6 mb-3">
                {t("documentation.simCards.simProfile.title")}
              </Card.Title>
              <Card.Text className="text-muted mb-3">
                {t("documentation.simCards.simProfile.description")}
              </Card.Text>
              <ul className="overview-list">
                <li>{t("documentation.simCards.simProfile.items.kpis")}</li>
                <li>{t("documentation.simCards.simProfile.items.monthly")}</li>
                <li>{t("documentation.simCards.simProfile.items.hlr")}</li>
                <li>
                  {t("documentation.simCards.simProfile.items.dataSessions")}
                </li>
                <li>{t("documentation.simCards.simProfile.items.smsUsage")}</li>
                <li>{t("documentation.simCards.simProfile.items.requests")}</li>
                <li>
                  {t("documentation.simCards.simProfile.items.provisioning")}
                </li>
                <li>{t("documentation.simCards.simProfile.items.cellInfo")}</li>
                <li>
                  {t("documentation.simCards.simProfile.items.watchdogs")}
                </li>
              </ul>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col lg={10}>
          <Card className="shadow-sm border-0 rounded-lg p-3">
            <Accordion
              defaultActiveKey="0"
              alwaysOpen
              className="simprofile-accordion"
            >
              {sections.map((s, idx) => {
                const bullets = t(
                  `documentation.simCards.simProfile.sections.${s.key}.bullets`,
                  { returnObjects: true, defaultValue: [] } // ✅ ensures always an array
                );
                const fields = t(
                  `documentation.simCards.simProfile.sections.${s.key}.fields`,
                  { returnObjects: true, defaultValue: {} } // default to object
                );

                return (
                  <Section
                    key={s.key}
                    eventKey={String(idx)}
                    title={t(
                      `documentation.simCards.simProfile.sections.${s.key}.title`,
                      ""
                    )}
                    description={t(
                      `documentation.simCards.simProfile.sections.${s.key}.description`,
                      ""
                    )}
                    bullets={Array.isArray(bullets) ? bullets : []} // ✅ safeguard
                    fields={typeof fields === "object" ? fields : {}} // ✅ object safeguard
                    images={s.images}
                  />
                );
              })}
            </Accordion>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default SimProfileDocs;
